import React from "react";
import { IonCard, IonCol, IonGrid, IonRow, IonText } from "@ionic/react";
import {
  NumberDecimal,
  NumberMoney,
} from "../../components/NumberMoney/NumberMoney";
import { useCart } from "./useCart";

interface IOrderPrice {
  deliveryInfo?: boolean;
}
export const OrderPriceDetails = (props: IOrderPrice) => {
  const {
    cartWeight,
    easelWood,
    easelAlum,
    frames,
    framesAssembled,
    colorPack,
    brandedBag,
    reserveCount,
    pricePictures,
    minMaxPicturePrice,
    pricePicturesKids,
    minMaxPicturePriceKids,
    priceEaselsWood,
    priceEaselsAlum,
    priceFrames,
    priceFramesAssembled,
    priceColorPack,
    priceBrandedBag,
    priceTotal,
    countPrice,
    countPriceKids,
    equipmentPrice,
  } = useCart();

  return (
    <IonCard>
      <IonGrid style={{ padding: "10px 10px 0 10px" }}>
        <IonRow
          style={{
            backgroundColor: "var(--ion-color-light-tint)",
            borderRadius: "5px",
          }}
        >
          <IonCol size="3">OPIS</IonCol>
          <IonCol size="4" className="ion-text-right">
            CENA
          </IonCol>
          <IonCol size="2" className="ion-text-center">
            KOL.
          </IonCol>
          <IonCol size="3" className="ion-text-right">
            UKUPNO
          </IonCol>
        </IonRow>
        {Boolean(countPrice) && (
          <IonRow>
            <IonCol size="5">Set za bojenje 40x50cm</IonCol>
            <IonCol size="2" className="ion-text-right">
              <NumberMoney
                minValue={minMaxPicturePrice().min}
                value={minMaxPicturePrice().max}
              />
            </IonCol>
            <IonCol size="2" className="ion-text-center">
              {countPrice}
            </IonCol>
            <IonCol size="3" className="ion-text-right">
              <NumberMoney value={pricePictures()} />
            </IonCol>
          </IonRow>
        )}
        {Boolean(countPriceKids) && (
          <IonRow>
            <IonCol size="5">Set za bojenje 20x20cm sa blind ramom</IonCol>
            <IonCol size="2" className="ion-text-right">
              <NumberMoney
                minValue={minMaxPicturePriceKids().min}
                value={minMaxPicturePriceKids().max}
              />
            </IonCol>
            <IonCol size="2" className="ion-text-center">
              {countPriceKids}
            </IonCol>
            <IonCol size="3" className="ion-text-right">
              <NumberMoney value={pricePicturesKids()} />
            </IonCol>
          </IonRow>
        )}
        {Boolean(frames) && (
          <IonRow>
            <IonCol size="5">Drveni (blind) ram 40x50cm</IonCol>
            <IonCol size="2" className="ion-text-right">
              <NumberMoney value={equipmentPrice.frame} />
            </IonCol>
            <IonCol size="2" className="ion-text-center">
              {frames}
            </IonCol>
            <IonCol size="3" className="ion-text-right">
              <NumberMoney value={priceFrames()} />
            </IonCol>
          </IonRow>
        )}
        {Boolean(framesAssembled) && (
          <IonRow>
            <IonCol size="5">Drveni (blind) ram 40x50cm - sklopljen</IonCol>
            <IonCol size="2" className="ion-text-right">
              <NumberMoney value={equipmentPrice.frameAssembled} />
            </IonCol>
            <IonCol size="2" className="ion-text-center">
              {framesAssembled}
            </IonCol>
            <IonCol size="3" className="ion-text-right">
              <NumberMoney value={priceFramesAssembled()} />
            </IonCol>
          </IonRow>
        )}
        {/* TO DO !!! */}
        {/* !!! PRICE_FRAME_PUT_TOGETHER */}
        {/* !!! fames_put_together */}
        {/* !!! priceFramesPutTogether() */}
        {/* <IonRow>
          <IonCol size="5">Usluga montiranja (blind) rama</IonCol>
          <IonCol size="2" className="ion-text-right">
            <NumberMoney value={equipmentPrice.frame} />
          </IonCol>
          <IonCol size="2" className="ion-text-center">
            {frames}
          </IonCol>
          <IonCol size="3" className="ion-text-right">
            <NumberMoney value={priceFrames()} />
          </IonCol>
        </IonRow> */}
        {Boolean(easelWood) && (
          <IonRow>
            <IonCol size="5">Drveni štafelaj</IonCol>
            <IonCol size="2" className="ion-text-right">
              <NumberMoney value={equipmentPrice.easelW} />
            </IonCol>
            <IonCol size="2" className="ion-text-center">
              {easelWood}
            </IonCol>
            <IonCol size="3" className="ion-text-right">
              <NumberMoney value={priceEaselsWood()} />
            </IonCol>
          </IonRow>
        )}
        {Boolean(easelAlum) && (
          <IonRow>
            <IonCol size="5">Aluminijumski štafelaj</IonCol>
            <IonCol size="2" className="ion-text-right">
              <NumberMoney value={equipmentPrice.easelA} />
            </IonCol>
            <IonCol size="2" className="ion-text-center">
              {easelAlum}
            </IonCol>
            <IonCol size="3" className="ion-text-right">
              <NumberMoney value={priceEaselsAlum()} />
            </IonCol>
          </IonRow>
        )}
        {Boolean(colorPack) && (
          <IonRow>
            <IonCol size="5">Set boja (dodatni)</IonCol>
            <IonCol size="2" className="ion-text-right">
              <NumberMoney value={equipmentPrice.colorPack} />
            </IonCol>
            <IonCol size="2" className="ion-text-center">
              {colorPack}
            </IonCol>
            <IonCol size="3" className="ion-text-right">
              <NumberMoney value={priceColorPack()} />
            </IonCol>
          </IonRow>
        )}
        {Boolean(brandedBag) && (
          <IonRow>
            <IonCol size="5">Brendirana kesa</IonCol>
            <IonCol size="2" className="ion-text-right">
              <NumberMoney value={equipmentPrice.brandedBag} />
            </IonCol>
            <IonCol size="2" className="ion-text-center">
              {brandedBag}
            </IonCol>
            <IonCol size="3" className="ion-text-right">
              <NumberMoney value={priceBrandedBag()} />
            </IonCol>
          </IonRow>
        )}
        <IonRow>
          <IonCol size="5">
            <strong>Poštarina</strong>
          </IonCol>
          <IonCol size="2" className="ion-text-right">
            <NumberMoney value={equipmentPrice.shipping} />
          </IonCol>
          <IonCol size="2" className="ion-text-center">
            1
          </IonCol>
          <IonCol size="3" className="ion-text-right">
            <NumberMoney value={equipmentPrice.shipping} />
          </IonCol>
        </IonRow>
      </IonGrid>
      <IonGrid style={{ padding: "0 10px 10px 10px" }}>
        <IonRow
          style={{
            backgroundColor: "var(--ion-color-light-tint)",
            borderRadius: "5px",
          }}
        >
          <IonCol size="8">
            <span className="b">SVE UKUPNO (sa poštarinom)</span>
          </IonCol>
          <IonCol size="4" className="ion-text-right">
            <span className="b">
              <NumberMoney value={priceTotal()} />
            </span>
          </IonCol>
        </IonRow>
        {props.deliveryInfo && (
          <IonRow>
            <IonCol style={{ paddingTop: 15 }}>
              <IonText>
                Težina vaše porudžbine je oko:{" "}
                <span className="b">
                  <NumberDecimal value={cartWeight} /> kg
                </span>
              </IonText>
            </IonCol>
          </IonRow>
        )}
        <IonRow>
          {reserveCount > 0 && (
            <IonCol size="12">Broj rezervacija: {reserveCount}</IonCol>
          )}
        </IonRow>
      </IonGrid>
    </IonCard>
  );
};
